import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    { icon: '🎯', title: 'Smart College Matching', text: 'Get the best MBBS colleges based on your NEET score, budget and preferred country.' },
    { icon: '🌍', title: '60+ Global Universities', text: 'All NMC-approved, across 15 countries with transparent fees.' },
    { icon: '📋', title: 'End-to-End Support', text: 'Docs, accommodation — we handle it all for you.' },
    { icon: '💸', title: '100% Free MBBS Counselling', text: 'No hidden charges. Our service to students is always free.' }
  ];

  const services = [
    { num: 1, title: 'Profile Analysis & College Shortlisting', sub: 'Instant college match report', tag: 'Free', tagClass: 'blue' },
    { num: 2, title: 'Application & Documentation', sub: 'SOP, transcripts, submissions', tag: 'Guided', tagClass: 'blue' },
    { num: 3, title: 'Accommodation & Travel', sub: 'Booking & forex support', tag: 'Included', tagClass: 'green' },
    { num: 4, title: 'Post-Arrival Support', sub: 'On-ground team in key countries', tag: 'Ongoing', tagClass: 'green' }
  ];

  return (
    <section className="section" id="features">
      <div className="section-inner">
        <div className="feat-wrap">
          <div className="feat-left reveal">
            <div className="sec-label">Why MyCollegeBuddy</div>
            <h2 className="sec-title">Everything You Need to Secure Your MBBS Seat</h2>
            <p className="sec-sub">We take the confusion out of medical admissions — whether you're looking at India or 15 countries abroad.</p>
            <div className="feat-grid">
              {features.map((feat, idx) => (
                <div className="feat-card" key={idx}>
                  <div className="feat-icon">{feat.icon}</div>
                  <div className="feat-title">{feat.title}</div>
                  <div className="feat-text">{feat.text}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="feat-right reveal">
            <div className="fr-header">
              <h3>What we handle for you</h3>
              <p>From profile analysis to landing in your new college city</p>
            </div>
            <div className="fr-body">
              {services.map((service, idx) => (
                <div className="fr-row" key={idx}>
                  <div className="fr-num">{service.num}</div>
                  <div className="fr-info">
                    <div className="fr-title">{service.title}</div>
                    <div className="fr-sub">{service.sub}</div>
                  </div>
                  <span className={`fr-tag ${service.tagClass}`}>{service.tag}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;